import React from "react";

import DynamicTable from "../../common/components/DynamicTable";
import LinkCellRenderer from "../../common/components/DynamicTable/LinkCellRenderer";

export default function Page() {
  const fields = {
    companyName: {
      cellRenderer: LinkCellRenderer.make((v, f, row) => {
        return `/companies/${row.companyId}`;
      }),
    },
  };

  return (
    <>
      <h1>Companies</h1>
      <DynamicTable endpoint={"/companies/table"} fields={fields} />
    </>
  );
}
